import dayjs from 'date'
import links, { getLinkWithParams } from 'links'


// TODO: Mock most of QueueModule.Item for CRO-51 ab test
// Think of a better way to get data for local queue items if the test wins - added by vlivanov on 16/12/2022
const modifyLocalQueueItems = (localItems: QueueModule.AddItemsInput): QueueModule.Items => {
  return localItems.map((queueItem, index): QueueModule.Item => {
    const { product } = queueItem

    const date = dayjs().add(index, 'month')
    const month = date.month() + 1
    const year = date.year()

    return {
      month,
      year,
      statuses: [],
      products: [ {
        flatIndex: index,
        tradingItem: {
          isLimitedEdition: product.isLimitedEdition,
          id: product.tradingItemId,
          productInfo: {
            id: product.productId,
            url: `${getLinkWithParams(links.productGeneral, { slug: product.productId })}`,
            image: product.image,
            rebrandImage: product.rebrandImage,
            name: product.name,
            fullName: product.name,
            brandInfo: { name: product.brand },
            upchargePrice: product.upchargePrice,
            // @ts-ignore
            rebrandLabels: {

            },
          },
          // @ts-ignore
          volume: {},
        },
        status: 'PRODUCT',
        stateOptions: {
          isBlocked: false,
          isMovable: true,
          isFree: false,
          isEmpty: false,
          isUnavailable: false,
          isDelivered: false,
        },
      } ],
      stateOptions: {
        isCancelled: false,
        isPaid: false,
        isLocked: false,
        isSkipped: false,
        isShipped: false,
        isDelivered: false,
        isPaused: false,
        isDisabled: false,
        isEmpty: false,
      },
    }
  })

}


export default modifyLocalQueueItems
